import React from 'react';
import { LeadOpsDashboard } from './pages/LeadOpsDashboard';
export function App() {
  return <LeadOpsDashboard data-id="element-0" />;
}